import React from "react";
import { PageHeader } from "../../components/Common"
import { BreadCrumbType } from '../../datatypes/datatypes';
import { strings } from "../../services/Localization"
import { getLabelBasedOnServerType } from './../../utils/consts';
import { useLocation } from "react-router";

export const StaticDocs: React.FC = () => {

    const fixedPath = "/app/static-docs";
    const loc = useLocation();
    const src = (loc.pathname.startsWith(fixedPath) ? loc.pathname.substring(fixedPath.length) : "");

    const breadCrumbArr: BreadCrumbType[] = [
        getLabelBasedOnServerType(strings.NAV_DEVELOPER, strings.NAV_HELP, ''),
        { label: strings.NAV_STATIC_DOC_ITEM, url: '' }
    ];

    return (
        <div className="child-tab-wrapper">
            <PageHeader breadCrumbArr={breadCrumbArr} pageButtons={[]}  />
            <div className="schema-engine-simple-page" style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                <iframe src={src} style={{width: "100%", height: "100%", border: "none", flex: "1 1 0%"}} />
            </div>
        </div>
    );
};
